export const country = [
  "كل الدول",
  "السعودية",
  "البحرين",
  "الامارات",
  "الكويت",
  "مصر",
  "الاردن",
  "قطر",
];
export const countryEn = [
  "All countries",
  "Saudi Arabia",
  "Bahrain",
  "United Arab Emirates",
  "Kuwait",
  "Egypt",
  "Jordan",
  "Qatar",
];
export const city = ["كل المدن", "الرياض", "جده", "الدمام"];
export const cityEn = ["All Cities", "Riyadh", "Jeddah", "Dammam"];
export const district = ["كل الاحياء", "الرائد", "عرقه", "حطين"];
export const districtEn = ["All Neighborhoods", "Al-Raed", "Irqah", "Hittin"];

export const numberofstudent = ["كل الاعداد", "100", "200", "400"];
export const numberofstudentEn = ["All Numbers", "100", "200", "400"];
export const budgetandfees = ["كل التكاليف المتوقعة", "1000", "5000", "10000"];
export const budgetandfeesEn = ["All Expected Costs", "1000", "5000", "10000"];
export const edusystem = [
  "كل الأنظمة",
  "النظام الأمريكي",
  "النظام البريطاني",
  "البكالوريا الدولية (IB)",
  "النظام الفرنسي",
  "النظام الألماني",
  "النظام الكندي",
  "النظام الأسترالي",
  "النظام الصيني",
  "النظام الهندي",
  "النظام السنغافوري",
  "النظام الوطني الأردني",
  "النظام الوطني للإمارات",
  "النظام الوطني السعودي",
];
export const edusystemEn = [
  "All Systems",
  "American system",
  "British system",
  "International Baccalaureate (IB)",
  "French system",
  "German system",
  "Canadian system",
  "Australian system",
  "Chinese system",
  "Indian system",
  "Singaporean system",
  "Jordanian national system",
  "The national system of the Emirates",
  "The national system of the Kingdom of Saudi Arabia",
];

export const educationLevel = ["كل المراحل", "ابتدائي", "متوسط", "ثانوي"];
export const educationLevelEn = [
  "All Stages",
  "Primary",
  "Intermediate",
  "Secondary",
];
export const ExtracurricularActivities = ["كل الأنشطة الغير منهجية"];
export const ExtracurricularActivitiesEn = ["All Extracurricular activities"];
export const SportsActivities = [
  "كل الأنشطة الرياضية",
  "كرة القدم",
  "كرة الطائره",
  "سباحة",
];
export const SportsActivitiesEn = [
  "All Sports activities",
  "Football",
  "Volleyball",
  "swimming",
];

export const countrySchoolForm = [
  "السعودية",
  "الدولة",
  "الدولة",
  "الدولة",
  "الدولة",
  "الدولة",
  "الدولة",
];
export const countrySchoolFormEng = [
  "Saudi Arabia",
  "country",
  "country",
  "country",
  "country",
  "country",
  "country",
];

export const citySchoolForm = [
  "الرياض",
  "المدينة",
  "المدينة",
  "المدينة",
  "المدينة",
  "المدينة",
];
export const citySchoolFormEng = [
  "Riyadh",
  "city",
  "city",
  "city",
  "city",
  "city",
];

export const districtSchoolForm = [
  "الرائد",
  "الحي",
  "الحي",
  "الحي",
  "الحي",
  "الحي",
];
export const districtSchoolFormEng = [
  "Alraid",
  "district",
  "district",
  "district",
  "district",
  "district",
];
export const selectionListCountry = [
  "كل المدن",
  "الرياض",
  "الظهران",
  "الدمام",
  "جدة",
  "مكة",
  "الطائف",
  "تبوك",
  "الخبر",
  "المدينة المنورة",
];
export const selectionListCountryEng = [
  "All cities",
  "Riyadh",
  "Dhahran",
  "Dammam",
  "Jeddah",
  "Macca",
  "Taif",
  "Tabuk",
  "Alkhobar",
  "Medina",
];
export const selectionListSystems = [
  "كل الأنظمة",
  "النظام الوطني السعودي",
  "النظام الوطني الأردني",
  "النظام الوطني للإمارات",
  "النظام الأمريكي",
  "النظام الفرنسي",
  "النظام الكندي",
  "النظام الصيني",
  "النظام الأسترالي",
  "النظام السنغافوري",
];
export const selectionListSystemsEng = [
  "All systems",
  "National system of Saudi Arabia",
  "Jordanian national system",
  "National system of the Emirates",
  "American system",
  "French system",
  "Canadian system",
  "Chinese system",
  "Australian system",
  "Singaporean system",
];
export const selectionListLevels = [
  "كل المراحل",
  "الروضة",
  "الابتدائية",
  "المتوسطة",
  "الثانوية",
];
export const selectionListLevelsEng = [
  "All stages",
  "Kindergarten",
  "Elementary school",
  "Middle school",
  "High school",
];
